import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import AlertMessage from '../../../../../components/AlertMessage';
import Button from '../../../../../components/Button';

import { required, minTextLength } from '../../../../../utils/validators';

class SuggestionForm extends Component {
  constructor(props) {
    super(props);
    this._minTextLength = minTextLength(20);
  }

  render() {
    const {
      onSubmit,
      handleSubmit,
      errorMessage,
      successMessage,
      invalid,
      onDismiss,
    } = this.props;

    if (successMessage) {
      return (
        <div>
          <AlertMessage success box message={successMessage} />
          <div className="SuggestionModal__footer">
            <Button
              type="submit"
              skin="primary"
              text="OK"
              onClick={onDismiss}
            />
          </div>
        </div>
      );
    }

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="SuggestionModal__text">
          Você tem alguma ideia para melhoria da Plataforma Luft? Nós queremos
          ouvir!
          <br />
          <br />
          Escreva no campo abaixo quais funcionalidades você gostaria de ter no
          sistema ou o que podemos fazer para melhorar sua experiência no
          sistema.
        </div>
        <Field
          name="suggestionText"
          floatingLabelText="Sugestões"
          fullWidth
          multiLine
          component={TextField}
          validate={[required, this._minTextLength]}
        />
        {errorMessage && <AlertMessage error box message={errorMessage} />}
        <div className="SuggestionModal__footer">
          <Button
            type="submit"
            skin="primary"
            text="ENVIAR"
            disabled={invalid}
          />
        </div>
      </form>
    );
  }
}

// Redux
const mapStateToProps = () => ({
  initialValues: {
    suggestionText: '',
  },
});

export default connect(mapStateToProps)(reduxForm({ form: 'suggestionForm' })(SuggestionForm));
